import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Maestria/Header';
import CourseDetails from '../components/Maestria/CourseDetails';
import CourseModules from '../components/Maestria/CourseModules';
import CallToAction from '../components/Maestria/CallToAction';
import CarruselFotos from '../components/Maestria/CarruselFotos'

const DiplomadoWebPage = () => {
  

  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>Diplomado en Ultrasonografía Diagnóstica - IMDI Tuxtla</title>        
        <meta name="description" content="Capacítate en ultrasonografía diagnóstica con IMDI Tuxtla. Diplomados en ultrasonido, ecografía y doppler materno fetal con expertos médicos." />
        <meta name="keywords" content="diplomados en ultrasonografía, ultrasonido diagnóstico, ecografía médica, doppler materno fetal, maestría en ultrasonografía" />
        <meta name="author" content="IMDI Tuxtla" />
        <link rel="canonical" href="https://imdituxtla.com.mx/Maestria" />
      </Helmet>

      <Header />
      <CourseDetails />
      <CourseModules />
      <CarruselFotos />
      <CallToAction />
    </div>
  );
};

export default DiplomadoWebPage;
